module.exports = __webpack_public_path__ + "static/media/icon-open-buy-big.fc624e53.svg";